module.exports = __webpack_public_path__ + "media/img/pages/profile/kpmg ger 4-5c2d44fb4ace8f93257bf820d4611110.jpg";